import { Directive, HostBinding, HostListener, output } from '@angular/core';

@Directive({ selector: '[appFileDragAndDrop]' })
/**
 *  Drag and Drop Directive
 *  Enables file upload via drag and drop on the component
 *  Emits dropped files as FileList
 *  Adds CSS Class "file-over" for highlighting if the drag is over the element
 */
export class DndDirective {
  @HostBinding('class.file-over') fileOver = false;
  readonly fileDropped = output<FileList>();

  /**
   * Dragover Listener
   * Tracks the Dragover Event
   *
   * @param evt DragEvent "dragover" which has been triggered
   */
  @HostListener('dragover', ['$event']) onDragOver(evt: DragEvent) {
    evt.preventDefault();
    evt.stopPropagation();
    this.fileOver = true;
  }

  /**
   * Dragleave Listener
   * Tracks the Dragleave Event
   *
   * @param evt DragEvent "dragleave" which has been triggered
   */
  @HostListener('dragleave', ['$event'])
  public onDragLeave(evt: DragEvent) {
    evt.preventDefault();
    evt.stopPropagation();
    this.fileOver = false;
  }

  /**
   * Drop Listener
   * Tracks the Drop event and checks wether files were dropped.
   * Emits Event with Dropped files as FileList
   *
   * @param evt DragEvent "drop" which has been triggered
   */
  @HostListener('drop', ['$event'])
  public onDrop(evt: DragEvent) {
    evt.preventDefault();
    evt.stopPropagation();
    this.fileOver = false;
    if (evt.dataTransfer) {
      const files = evt.dataTransfer.files;
      if (files.length > 0) {
        this.fileDropped.emit(files);
      }
    }
  }
}
